import { transferOrderIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const deleteTransfer = {
  name: "deleteTransfer" as const,
  input: z.object({ transferId: transferOrderIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
